import * as actionType from '../action-type';

export const updateNwfaSandFinishReport = (data) => ({
  type: actionType.UPDATE_NWFA_SAND_FINISH_REPORT,
  payload: data,
});

export const resetNwfaSandFinishReport = () => ({
  type: actionType.RESET_NWFA_SAND_FINISH_REPORT,
});